import { render, staticRenderFns } from "./SettingsLabelDropbox.vue?vue&type=template&id=80429404&scoped=true"
import script from "./SettingsLabelDropbox.vue?vue&type=script&lang=js"
export * from "./SettingsLabelDropbox.vue?vue&type=script&lang=js"
import style0 from "./SettingsLabelDropbox.vue?vue&type=style&index=0&id=80429404&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80429404",
  null
  
)

export default component.exports